import { TableBody as MuiTableBody } from "@mui/material";
import { useBatchApproveAllowancePreviewContext } from "src/views/AssetManagement/BatchApproveAllowance/contexts";
import { setSingleAddressSelection } from "../helpers/selectionHelpers";
import TableBodyRow from "./components/TableBodyRow";

function TableBody() {
  const {
    walletMajorVersion,
    sendingAddressesMap,
    setSendingAddressesMap,
    submitParams,
    toDisplayAmountWithCurrency,
  } = useBatchApproveAllowancePreviewContext();

  return (
    <MuiTableBody>
      {Array.from(sendingAddressesMap.entries())
        .filter(([_, senderInfo]) => {
          return senderInfo.walletMajorVersion === walletMajorVersion;
        })
        .map(([sendingAddress, senderInfo], index) => (
          <TableBodyRow
            key={sendingAddress}
            serialNumber={index + 1}
            sendingAddress={sendingAddress}
            senderInfo={senderInfo}
            spenderAddress={submitParams.spenderAddress}
            toDisplayAmountWithCurrency={toDisplayAmountWithCurrency}
            onToggleAddress={(address, isChecked) => {
              setSendingAddressesMap((prev) =>
                setSingleAddressSelection(prev, address, isChecked),
              );
            }}
          />
        ))}
    </MuiTableBody>
  );
}

export default TableBody;
